// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asc-components-failed[data-v-30e0ca27]{width:100%}.asc-components-failed h1[data-v-30e0ca27]{font-weight:700;font-size:16px;line-height:16px;color:#233238}.asc-components-failed p[data-v-30e0ca27]{font-size:15px;line-height:19px;color:#233238}.asc-components-failed svg[data-v-30e0ca27]{fill:green}", ""]);
// Exports
module.exports = exports;
